import { api, helpers, ts } from '_core';

type BasketApiResponse = {
  data: ts.types.basket.Basket;
};

export const createBasket = async (
  newData: ts.types.basket.BasketDraft,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BasketApiResponse = await api.baskets.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating basket - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateBasket = async (
  id: number,
  newData: ts.types.basket.BasketDraft,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BasketApiResponse = await api.baskets.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating basket - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.basket.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.baskets.update(
      id,
      {
        definition,
        is_valid: isValid,
        skip_signature_check: !isValid,
      },
      true
    );
    if (resp.data?.validation_error && !resp.data?.is_valid) errorCallback(resp.data?.validation_error);
    else callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
